/* istanbul ignore file */
import React, { useEffect, useMemo, useState } from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useParams } from 'react-router-dom';
import { useVacancyPublicationUrl } from 'domain/recruiting/vacancy/publication/vacancyPublicationRoute';
import VacancyPublicationBreadcrumbs from 'domain/recruiting/vacancy/publication/shared/VacancyPublicationBreadcrumbs';
import { useShowContext } from 'framework/show';
import { useFormContext } from 'framework/form';

const SingleVacancyPublicationBreadcrumbs = ({ children }: any) => {
  const { getSingleEntityUrl } = useVacancyPublicationUrl();
  // @ts-ignore
  const { id } = useParams<Dictionary<string>>();
  const { data } = useShowContext();
  const { data: formData } = useFormContext();
  const [initialEntityName, setInitialEntityName] = useState<string | null>(null);

  useEffect(() => {
    if (!initialEntityName && formData?.name) {
      setInitialEntityName(formData.name);
    }
  }, [formData?.name, initialEntityName]);

  const entity = useMemo(() => {
    return initialEntityName || data.getValueBySource('name');
  }, [data, initialEntityName]);

  return (
    <VacancyPublicationBreadcrumbs>
      <SingleBreadcrumbItem entity={entity} link={getSingleEntityUrl(id)} />
      {children}
    </VacancyPublicationBreadcrumbs>
  );
};

export default SingleVacancyPublicationBreadcrumbs;
